import { z } from 'zod';
import type { Candidate } from '@/Models/Candidate';
import UIStrings from '@/Utils/UIStrings';

export const candidateSchema = z.object({
    id: z.string(),
    firstName: z
        .string()
        .min(1, { message: UIStrings.Required })
        .max(128, { error: ({ maximum }) => UIStrings.MaxSymbolsValidationError(maximum) }),
    lastName: z
        .string()
        .min(1, { message: UIStrings.Required })
        .max(128, { error: ({ maximum }) => UIStrings.MaxSymbolsValidationError(maximum) }),
    email: z
        .string()
        .min(1, { message: UIStrings.Required })
        .max(128, { error: ({ maximum }) => UIStrings.MaxSymbolsValidationError(maximum) })
        .pipe(z.email({ error: UIStrings.PleaseEnterValidEmailAddress })),
    isInternal: z.boolean(),
});

export type CandidateFormValues = z.infer<typeof candidateSchema>;

export const defaultCandidateFormValues: Candidate = {
    email: '',
    id: '',
    firstName: '',
    lastName: '',
    isInternal: false,
};
